import { render, staticRenderFns } from "./AdwordsVisuals.vue?vue&type=template&id=6885de73"
import script from "./AdwordsVisuals.vue?vue&type=script&lang=js"
export * from "./AdwordsVisuals.vue?vue&type=script&lang=js"
import style0 from "./AdwordsVisuals.vue?vue&type=style&index=0&id=6885de73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports